import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import {
  getPenStudyAnalyses,
  getPenStudyAnalysis,
  clearLocalPenStudyAnalyses,
  clearLocalActivePenStudyAnalysis
} from './actions';

const initialState = {
  all: { data: [], pagination: { limit: 25, offset: 0, count: 0, total_count: 0 }},
  penStudyAnalysis: { id: '', result: '', status: '', updated_at: '' },
  loading: { all: false, penStudyAnalysis: false }
};

const slice = createSlice({
  name: 'penStudyAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getPenStudyAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getPenStudyAnalyses.fulfilled, (state, action) => {
        const { pen_study_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...pen_study_analyses], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getPenStudyAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getPenStudyAnalysis.pending, (state) => {
        state.loading.penStudyAnalysis = true;
      })
      .addCase(getPenStudyAnalysis.fulfilled, (state, action) => {
        const { data: { pen_study_analysis }, cable } = action.payload;
        const foundedPenStudyAnalysis = !!_find(state.all.data, (s) => s.id === pen_study_analysis.id);
        const updatedPenStudyAnalysis = { ...state.penStudyAnalysis, ...pen_study_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedPenStudyAnalysis ? _map(state.all.data, (e) => e.id === pen_study_analysis.id ? { ...e, ...pen_study_analysis } : e) : [...[pen_study_analysis], ...oldAllData]; 
        const pagination = foundedPenStudyAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.penStudyAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedPenStudyAnalysis && !cable) state.penStudyAnalysis = updatedPenStudyAnalysis;       
      })
      .addCase(getPenStudyAnalysis.rejected, (state) => {
        state.loading.penStudyAnalysis = false;
      })
      .addCase(clearLocalPenStudyAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActivePenStudyAnalysis, state => {
        state.penStudyAnalysis = initialState.penStudyAnalysis;
      })
  }
})

export default slice.reducer;